<template>
  <div class="modelcover" @click="handleCloseSign">
    <div class="sigin" @click.stop="">
    		<div class="modal">
    			<div class="title">
    				用户注册
    			</div>
    			<div class="flex list" style="margin-top: 50px;">
    				<img src="../assets/img/usericon.png" width="19" height="20">
    				<input type="tel" name="" maxlength="11" id="" value="" placeholder="请输入手机号" v-model="phone" style="flex:1;" />
            <img :src="kaptchaPic" v-if="kaptchaPic" class="number" @click="getKaptcha"/>
    			</div>
          <div class="flex list">
            <img src="../assets/img/codeicon.png" width="19" height="20" >
          	<input maxlength="11"  v-model="kaptcha" placeholder="请输入运算结果">
          </div>
    			<div class="flex list">
    				<img src="../assets/img/codeicon.png" width="19" height="20" >
    				<input type="tel" name="" id="" value="" placeholder="请输入短信验证码" class="flex1" v-model="code" />
    				<span style="color: #4fa7ff;cursor: pointer;" v-if="canget" @click="handleGetCode()">获取验证码</span>
    				<span style="color: #4fa7ff;cursor: pointer;" v-else>{{seconds}}s</span>
    			</div>
    			<div class="flex list">
    				<img src="../assets/img/passwordicon.png" width="18" height="20" >
    				<input type="password" name="" id="" value="" placeholder="请输入密码" v-model="password" />
    			</div>
    			<div class="flex" style="margin-top: 30px;align-items: center;font-size: 14px;">
    				<input type="checkbox" name="" id="checkbox" value=""  />
    				<span style="color: #999;margin-left: 5px;">阅读并同意</span><span style="color: #4fa7ff;cursor: pointer;" @click="handleUseragent">《用户协议》</span>
    				<span style="color: #4fa7ff;cursor: pointer;" @click="privacypolicy">《隐私政策》</span>
    			</div>
    			<div class="btn" style="cursor: pointer;" @click="handleSubmit" >
    				注册
    			</div>
    			<div class="text-center"  style="color: #4fa7ff;margin-top: 10px;font-size: 14px;cursor: pointer;" @click="handleOpenLogin">
    				已有账号，请登录
    			</div>
    		</div>
    </div>
  </div>
</template>

<script>
  let timer;
  export default {
    name: 'Footer',
    components:{

    },
    data () {
      return {
          showLogin:false,
          phone: '',
          code: '',
          password: '',
          codeText: '获取验证码',
          uuid: '',
          ischeck:false,
          seconds:60,
          canget:true,
          kaptchaPic:'',
          kaptcha:'',
      }
    },
    watch: {
    	phone(val) {

    		if (val.length == 11) {
    			this.getKaptcha();
    		}
    	}
    },
    methods:{
      getKaptcha() { // 获取图形验证码
      	this.kaptchaPic = 'http://app.pstedu.com/api/login/kaptcha?phone='+this.phone+'&t='+new Date().getTime()
      },
      handleCloseSign(){
        this.$emit('handleCloseSign')
      },
      handleOpenLogin(){
        this.$emit('handleOpenLogin')
      },
      handleUseragent(){
        this.$emit('cancelsign')
        this.$router.push({path: '/useragreement'})
      },
      privacypolicy(){
        this.$emit('cancelsign')
        this.$router.push({path: '/privacypolicy'})
      },
      handleGetCode(){
        if(!/^1\d{10}$/.test(this.phone)){

          alert('请输入正确的手机号码');
          return ;
        }
        if(!this.kaptcha){
          alert('请输入图片验证码结果');
          return;
        }
        let data=new FormData();
            data.append('phone',this.phone);
            data.append('templateType',1);
            data.append('kaptcha',this.kaptcha)
        this.$axios.post(this.$common.sendSMS_url,data).then((res)=>{
              if(res.data.code==1){
                  clearInterval(timer)
                  this.canget=false;
                  this.uuid=res.data.data;
                  timer=setInterval(()=>{
                    if(this.seconds==0){
                      clearInterval(timer);
                      this.canget=true;
                      this.seconds=60
                    }
                    else {
                      this.seconds--;
                    }
                  },1000)

              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handleSubmit(){

        if(!/^1\d{10}$/.test(this.phone)){

          alert('请输入正确的手机号码');
          return ;
        }
        if(this.password.length<6){
          alert('密码不能少于6位');

          return ;
        }
        if(!/^\d{6}$/.test(this.code)){

          alert('请输入6位验证码');
          return ;
        }
        if(document.querySelector('#checkbox').checked===false){
          alert('请阅读并同意《用户协议》《隐私政策》');
          return ;
        }
        let data=new FormData();
            data.append('phone',this.phone);
            data.append('code',this.code);
            data.append('uuid',this.uuid);
            data.append('password',this.password);
            data.append('loginType',3);
        this.$axios.post(this.$common.login_url,data).then((res)=>{
              if(res.data.code==1){
                window.sessionStorage.token=res.data.data;
                this.phone='';
                this.code=''
                this.$emit('handleCloseSign')
              }
              else {
                alert(res.data.msg)
              }
        })
      }
    }
  }
</script>

<style scoped>
  .modelcover {
    width: 100%;
        height: 100%;
        background-color: rgba(34, 34, 34, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        position: fixed;
        left: 0;
        z-index: 1988;
  }
  .sigin {
  	width: 390px;
  	    height: 465px;
  	    border-radius: 10px;
  	    background-color: rgba(255, 255, 255, 1);
  	    position: relative;
  		padding: 30px;
      z-index: 1988;
  }
  .sigin .title {
  	font-size: 24px;
  }
  .sigin input {
  	border: none;
  	line-height: 40px;
  	outline: none;
  	text-indent: 15px;
  	font-size: 16px;
  }
  .sigin .list {
  	border-bottom: 1px solid #eee;
  	align-items: center;
  	margin-top: 15px;
  }
  .sigin .btn {
  	height: 50px;
  	text-align: center;
  	line-height: 50px;
  	color: #fff;
  	background-color: #4fa7ff;
  	border-radius: 4px;
  	margin-top: 50px;
  	font-size: 18px;
  }
  .number {
    height: 40px;
    width: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/signin.vue